import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ServiceCarousel from '../../components/ServiceCarousel';
import './Home.css';
import startNowImage from '../../assets/images/start-now.svg';

const Home = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const services = [
    {
      id: 1,
      title: t('services.translation'),
    },
    {
      id: 2,
      title: t('services.translators-training'),
    },
    {
      id: 3,
      title: t('services.researchers-training'),
    },
    {
      id: 4,
      title: t('services.research-review'),
    }
  ];

  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>{t('hero.title')}</h1>
            <Link to="/services" className="cta-button">
              {t('home.request_translation')}
            </Link>
          </div>
        </div>
      </section>

      <section className="about-section" id="about-section">
        <div className="container">
          <h2 className="section-title">{t('nav.about')}</h2>

          <div className="about-content">
            <p className="about-text">
              {t('home.about_text_1')}
            </p>
            <p className="about-text">
              {t('home.about_text_2')}
            </p>
            <p className="about-text highlight">
              {t('home.about_highlight')}
            </p>

            <div className="about-link">
              <svg style={{ marginTop: '5px' }} xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                <path d="M31.0607 13.0607C31.6464 12.4749 31.6464 11.5251 31.0607 10.9393L21.5147 1.3934C20.9289 0.807611 19.9792 0.807611 19.3934 1.3934C18.8076 1.97919 18.8076 2.92893 19.3934 3.51472L27.8787 12L19.3934 20.4853C18.8076 21.0711 18.8076 22.0208 19.3934 22.6066C19.9792 23.1924 20.9289 23.1924 21.5147 22.6066L31.0607 13.0607ZM0 13.5H30V10.5H0L0 13.5Z" fill="#4DAAA7" />
              </svg> {t('home.meet_our_team')}
            </div>
          </div>
        </div>
      </section>

      <section className="services">
        <div className="container">
          <h2 className="section-title text-center">{t('services.title')}</h2>
          <ServiceCarousel services={services} />
        </div>
      </section>

      <section className="two-columns-section">
        <div className="container" style={{ overflow: 'visible' }}>
          <div className="two-columns-grid start-now-grid" style={{ overflow: 'visible',
            position:'relative',
           }}>
            {isRtl ? (
              <>
                <div className="column left-column">
                  <img src={startNowImage} alt={t('home.start_now_alt')} className="start-now-image" />
                </div>
                <div className="column right-column">
                  <h2 className="section-title start-now-title"><span className="primary-color">{t('home.request')}</span> {t('home.your_translation')} <span className="primary-color">{t('home.now')}</span></h2>
                  <p className="start-now-text">
                    {t('home.start_now_text')}
                  </p>
                  <div className="start-now-actions">
                    <Link to="/workflow" className="workflow-link">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none" style={{ verticalAlign: 'middle', marginLeft: '10px' }}>
                        <path d="M31.0607 13.0607C31.6464 12.4749 31.6464 11.5251 31.0607 10.9393L21.5147 1.3934C20.9289 0.807615 19.9792 0.807615 19.3934 1.3934C18.8076 1.97919 18.8076 2.92894 19.3934 3.51472L27.8787 12L19.3934 20.4853C18.8076 21.0711 18.8076 22.0208 19.3934 22.6066C19.9792 23.1924 20.9289 23.1924 21.5147 22.6066L31.0607 13.0607ZM-2.62268e-07 13.5L30 13.5L30 10.5L2.62268e-07 10.5L-2.62268e-07 13.5Z" fill="white" />
                      </svg>
                      {t('home.workflow')}
                    </Link>
                    <Link to="/services" className="cta-button start-now-button">{t('home.upload_file')}</Link>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="column right-column">
                  <h2 className="section-title start-now-title"><span className="primary-color">{t('home.request')}</span> {t('home.your_translation')} <span className="primary-color">{t('home.now')}</span></h2>
                  <p className="start-now-text">
                    {t('home.start_now_text')}
                  </p>
                  <div className="start-now-actions">
                    <Link to="/workflow" className="workflow-link">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none" style={{ verticalAlign: 'middle', marginLeft: '10px' }}>
                        <path d="M31.0607 13.0607C31.6464 12.4749 31.6464 11.5251 31.0607 10.9393L21.5147 1.3934C20.9289 0.807615 19.9792 0.807615 19.3934 1.3934C18.8076 1.97919 18.8076 2.92894 19.3934 3.51472L27.8787 12L19.3934 20.4853C18.8076 21.0711 18.8076 22.0208 19.3934 22.6066C19.9792 23.1924 20.9289 23.1924 21.5147 22.6066L31.0607 13.0607ZM-2.62268e-07 13.5L30 13.5L30 10.5L2.62268e-07 10.5L-2.62268e-07 13.5Z" fill="white" />
                      </svg>
                      {t('home.workflow')}
                    </Link>
                    <Link to="/services" className="cta-button start-now-button">{t('home.upload_file')}</Link>
                  </div>
                </div>
                <div className="column left-column">
                  <img src={startNowImage} alt={t('home.start_now_alt')} className="start-now-image" />
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>{t('home.ready_to_start')}</h2>
            <p>{t('home.cta_description')}</p>
            <Link to="/upload" className="btn btn-primary">
              {t('hero.cta')}
            </Link>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home; 